export class SupportCommentDto {
    public orderID: string;
    public comment: string;
}
